import React, { useState, useEffect, useMemo } from "react";
import eventClasses from "./seaeditevent.module.scss";
import classes from "../../controls.module.scss"
import {
    FormControlLabel,
    FormControl,
    TextField,
    Button,
    Grid
  } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import  useToggle  from "@genesis/ui-kit/dist/hooks/useToggle";
import { useLocation } from "react-router-dom";
import NotificationView from "../../../../Shared/Notification/NotificationView";
import { useNavigate, NavLink, Link } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "../../DivisionDropdown/DivisionDropdownComp";
import duplicate from "../../../../Resources/duplicate.png";
import deleteimg from "../../../../Resources/delete.png";
import add_disable from "../../../../Resources/add_disable.png";
import duplicate_disable from "../../../../Resources/duplicate_disable.png";
import delete_disable from "../../../../Resources/delete_disable.png";
import DeleteEventDialog from "../../EventParentControls/DeleteEvent/DeleteEventDialog";
import DuplicateEventDialog from "../../EventParentControls/DuplicateEvent/DuplicateEventDialog";
import EventLocationsDialog from "../../EventParentControls/EventLocationsList/EventLocationsDialog";


const EditEventsPage = () => {
    const personDetails = useSelector((state) => state.person.personData);
    const personStaticDetails = useSelector((state) => state.personStatic.personStaticData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const token = Cookie.get('X_TKN');
    const dialog = useToggle();
    const location = useLocation();
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const [division, setDivision] = React.useState("");
    const [eventLocation, setEventLocation] = React.useState("");
    const [eventId, setEventId] = React.useState("");
    console.log("data from search parent!"+ JSON.stringify(location.state.data))
    const [eventBaseData, setEventBaseData] = React.useState(location.state.data);
    const [flag, setFlag] = React.useState(location.state.flag);
    const history = useNavigate();
    const [eventApiData, setEventApiData] = React.useState();
    const { message, severity, open } = isAlertOpen || {};
    const [readOnlyView,setReadyOnly] = React.useState(true);
    const [ongoingActionCompleted, setOngoingActionCompleted] = React.useState(true);
    const [activateEvent,setActivateEvent] = React.useState(true)
    const [useBaseData,setUseBaseData] = useState(true);
    const [useApiData,setUseApiData] = useState(true);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);
    const [lastUpdatedDate,setLastUpdatedDate] = useState("")
    const [createDate,setCreateDate] = useState("")


    // Add
    const [eventName, setEventName] = React.useState("");
    const [eventName2, setEventName2] = React.useState("");
    const [showLocations,setShowLocations] = React.useState(false)

    useEffect(() => {
        if((eventBaseData !== null) && (eventBaseData !== undefined) ) {
            console.log(flag)
            setUseBaseData(true);
            if(flag === 'E') {
                
                if (useBaseData && ongoingActionCompleted) {
                //setEventName(eventBaseData.eventname)
                setDivision(eventBaseData.divnbr)
                setEventId(eventBaseData.eventid)
                } 
            }
           
         //getEventDetailsApi(); 
        } else if (!useApiData){
            console.log(flag)
            // set flag to A
            setFlag("A");
            setUseBaseData(false);
            setReadyOnly(false);
            setOngoingActionCompleted(false);
            //setEventApiData(null)
        }
         
     },[ongoingActionCompleted,eventApiData,eventBaseData]);
 

       useEffect(() => {
        if ((flag === "E") && (eventApiData == undefined)){
            setUseBaseData(false) 
        }

         if((flag === "E") && (eventApiData == undefined) && (ongoingActionCompleted)){
            getEventApi()
         }
         
       },[flag]);


    const handleChange = (event) => {
       setEventName(event.target.value)
      };

    const cancelEditing = () => {
        setOngoingActionCompleted(true);
        // call api to reset values
        makeReadOnly();
      }

    const makeEditable = () => {
        setOngoingActionCompleted(false);
        console.log(readOnlyView + " ready only ")
        if (readOnlyView == true) {
            setReadyOnly(false)
        } 
    }
    const makeReadOnly = () => {
        //on click of save
        setOngoingActionCompleted(true);
        if (readOnlyView == false) {
            setReadyOnly(true)
        } 
    }

    const changeActivateEvent = (e) => {
        setActivateEvent(e.target.checked)
    }

    const handleAlertNotifClose = () => {
        setAlertOpen({});
      };

    const handleCancel = () => history('/controls/specialeventscontrols/eventcontrols');

    const onDivDropDownSelect = (selectedDivision) => {
       // setDivSelectedValue(selectedDivision);
        if (selectedDivision!==null && selectedDivision!==undefined) {
          console.log(selectedDivision.divNbr);
          setDivision(selectedDivision.divNbr);
        }
      }

     const getEventApi = async (div = null, edit = null) => {
        
        let data = {
            divNbr:  div !== null ? div : eventBaseData.divnbr,
            eventName: edit !== null ? edit : eventBaseData.eventname
        }
        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_GET_BY_DIV_NBR_EVENT_NAME}`,
            data,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then((response) => {
                console.log("response is", response.data)
                setUseBaseData(false);
                setEventApiData(response.data);
                setEventName(response.data[0].eventName)
                setEventName2(response.data[0].eventName)
                setEventId(response.data[0].eventId);
                setCreateDate(response.data[0].createDate);
                setLastUpdatedDate(response.data[0].lastUpdateDate)
                console.log(eventApiData[0])
                if (ongoingActionCompleted) {
                    setUseApiData(true);
                    setDivision(response.data[0].divNbr);
                    setEventId(response.data[0].eventId);
                    setEventName(response.data[0].eventName);
                    setEventName2(response.data[0].eventName);
                    setCreateDate(response.data[0].createDate);
                setLastUpdatedDate(response.data[0].lastUpdateDate)
                }    
            })
            .catch((error) => {
                if(error.message === 'Network Error') {
                    history("/somethingwentwrong", {state:`Please logout and try again `})
                  }

            })
    }
   
      const saveData = () => {
        if (flag === "E") {
            console.log(division)
            console.log(eventApiData)
        let data = {
            eventId: eventId,
            divNbr: division,
            eventName: eventName,
            createDate:createDate,
            lastUpdatedBy: personStaticDetails.emplID,
            lastUpdateDate:lastUpdatedDate
        }

        axiosInstance.put(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_UPDATE_BY_EVENT_ID}/${eventId}`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token,
                }
            }).then((res) => {
                // call api to fetch data                
                setAlertOpen({
                    open: true,
                    severity: "success",
                    message : "Event saved successfully",
                  })
                  makeReadOnly();
                  getEventApi(division,eventName)

            }).catch((err) => {
                setAlertOpen({
                    open: true,
                    severity: "error",
                    message : err.response.data.message,
                  })
            });
         // end of edit save
        } else if (flag === "A") {
            console.log(division)
            let data = {
                divNbr: division,
                eventName: eventName,
                lastUpdatedBy: personStaticDetails.emplID,
            }
          
            axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_ADD_BY_DIV_NBR_EVENT_NAME}`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token,
                    }
                }).then((res) => {
                    console.log(res)                    
                    setAlertOpen({
                        open: true,
                        severity: "success",
                        message : "Event saved successfully",
                      })
                    setOngoingActionCompleted(true)
                    setFlag("E")
                    setUseBaseData(false);
                    setEventBaseData(null);
                    setEventId(res.data.eventId)
                    setDivision(res.data.divNbr)
                    setEventName(res.data.eventName);
                    setEventName2(res.data.eventName);
                    //history("Edit", { state: {data: res.data, flag: "E",replace:true}})               
                }).catch((err) => {
                    setAlertOpen({
                        open: true,
                        severity: "error",
                        message : err.response.data.message,
                      })
                });
             // end of save for add
        }
      
        
    }

    const onCloseDialog = () => {
        setOpenDeleteDialog(false);
        setOpenDuplicateDialog(false);
        //
        setShowLocations(false);
    }

    const listLocations = () => {
        setShowLocations(true);
    }
   
    const onDeleteCallback = (responseType,message) => {
        onCloseDialog();
        //handle success / failue
        setAlertOpen({
          open: true,
          severity: responseType,
          message : message,
        });
        // refresh data
        if(responseType == 'success'){
         // navigate back to event search page
         history('/controls/specialeventscontrols/eventcontrols',{state:true,stateDelete: true});
        }
      }

     const onDuplicateCallback = (responseType,message,resp) => {
        onCloseDialog();
        //handle success / failue
        setAlertOpen({
          open: true,
          severity: responseType,
          message : message,
        });
        setFlag("E");
        setEventName(resp.eventName);
        setEventName2(resp.eventName);
        setEventId(resp.eventId);
        //: refresh page data to load data
       // getEventApi(division,resp.eventName); // not required to refresh
       
      }  
    const onDeleteAction = () => {
        setOpenDeleteDialog(true);
    }

    const onDuplicateAction = () => {
        setOpenDuplicateDialog(true);
    }

    if (flag === "E" ) {
        return (
          
            <div className={eventClasses.eventpagemargin}>
    
            <div style={{width:"100%"}}>
                <div className="eventpagetitle" style={{textAlign:"left", width:"40%",marginTop:"-.95%"}} >{eventName}</div>
                <div className="eventpagetitle2" style={{textAlign:"right", width:"55%" }}>
                
                    <div  
                    className="eventicon2" 
                    onClick={() => (ongoingActionCompleted && eventBaseData) ? onDuplicateAction() : null}
                     >
                        <img height={20} width={20} className="images" src={(ongoingActionCompleted && eventBaseData && eventBaseData.location_count > 0) ? duplicate: duplicate_disable}   />
                        <div className= {eventClasses.icon_text} style={{ pointerEvents:(ongoingActionCompleted && eventBaseData && eventBaseData.location_count > 0) ? "auto":"none" ,color : (ongoingActionCompleted && eventBaseData && eventBaseData.location_count > 0) ? "inherit" : "grey", display:"inline-block", marginLeft:"5px",cursor:"pointer",textDecoration:"underline"}} >
                            <div className={eventClasses.test}>
                            Duplicate 
                            </div>
                            
                        </div>
                    </div>
                    <div className="eventicon2" onClick={() => ongoingActionCompleted ? onDeleteAction() : null}> 
                    <img className="images" src={ongoingActionCompleted ? deleteimg : delete_disable}   /> 
                        <span style={{pointerEvents:(ongoingActionCompleted && eventBaseData) ? "auto":"none" ,color : ongoingActionCompleted ? "inherit" : "grey" , marginLeft:"5px",cursor:"pointer",textDecoration:"underline"}} >Delete</span> 
                    </div>    
                </div>
            </div>
            <div className="editMessage">
                <div className={eventClasses.editMessage}>
                {readOnlyView &&
                <NotificationView 
                    message={"'Read-only' view, click on 'Edit' to edit event details."} 
                    severity="info"
                    specify = "infoEditParent"
                    />
                    
                }
                </div>
            </div>
                <div className={eventClasses.eventiconmargin}>
                    
            
            <div className={classes.pagesubtitle}> </div>
            { /*  Event details code goes here */}
    
            <div>
           
                
            <div className={eventClasses.eventpagemargin}>
    
                  
                <Grid container spacing={4} >
                
                <Grid item xs={2}>
                    <div className="eventDetails"> Event Details </div>
                    </Grid>
    
                <Grid item xs={2} >
                {( (useBaseData) && (eventBaseData !== undefined) )&&
                    <TextField inputProps={{ readOnly: true }} sx={{ minWidth:"100%" }} label="Division" value={eventBaseData.division}/>
                }
                {(useApiData && !useBaseData) &&
                    <TextField inputProps={{ readOnly: true }} sx={{ minWidth:"100%" }} label="Division" value={division}/>
                }

                
                </Grid>

                <Grid item xs={2}>
                {/* {( (useBaseData) && (eventBaseData !== undefined) ) &&
                <TextField inputProps={{ readOnly: true }} sx={{ minWidth:"100%" }} label="Event ID" value={eventBaseData.eventid} />
                }
                { (useApiData && !useBaseData) &&
                    <TextField inputProps={{ readOnly: true }} sx={{ minWidth:"100%" }} label="Event ID" value={eventId} />
                } */}
                <TextField inputProps={{ readOnly: true }} sx={{ minWidth:"100%" }} label="Event ID" value={eventId} />

                </Grid>
                <Grid item xs={2}>
                {readOnlyView ? <TextField inputProps={{ readOnly: true }} sx={{ minWidth:"100%" }} label="Event Name" value={eventName}/> 
                 : <TextField 
                 inputProps={{ readOnly: false }} 
                 sx={{ minWidth:"100%" }} 
                 label="Event Name" 
                 value={eventName} 
                 onChange={(e)=> handleChange(e)}

                 /> 
                    
                }
                </Grid>
                <Grid item xs={2} >
                <Grid item xs={2}>
                    { 
                            <a onClick={() => listLocations()} style={{cursor: 'pointer', textDecoration: "underline" }}>Location(s)</a>
                    }
                </Grid>
                </Grid>
                <Grid  item xs={2}>
                </Grid>
                <Grid item xs={2}>
                </Grid>
                <Grid item xs={2} >
                </Grid>
                <Grid item xs={2} >
                </Grid>
                <Grid item xs={2} >
                    <FormControl>
                    
                    </FormControl>
                </Grid>
            </Grid>
            </div>
            <Grid container spacing={4} >
            <Grid item xs={2} > </Grid>
            <Grid item xs={2} > </Grid>
            <Grid item xs={2} >
                        {!readOnlyView && <Button sx={{ minWidth: "100%" , minHeight: '120%' }} color="secondary" onClick={cancelEditing} >Cancel</Button> }
                        </Grid>
             <Grid item xs={2} > 
                            {readOnlyView &&
                                <Button sx={{ minWidth: "100%"  ,minHeight: '120%'}} onClick={makeEditable} >Edit</Button>
                            }
                            {!readOnlyView &&    
                                <Button sx={{ minWidth: "100%",  minHeight: '120%' }} onClick={saveData} >Save</Button>}

            </Grid>
            </Grid>
        </div>  

           
                <SnackBar
            open={open}
            message={message}
            severity={severity}
            onClose={handleAlertNotifClose}
            ></SnackBar>
          {openDeleteDialog && <DeleteEventDialog onCloseDialog={onCloseDialog} onDeleteCallback={onDeleteCallback} data={eventId}/>}
          {openDuplicateDialog && <DuplicateEventDialog onCloseDialog={onCloseDialog} onDuplicateCallback={onDuplicateCallback} eventId={eventId} eventName={eventName}/>}
          {showLocations &&  <EventLocationsDialog onCloseDialog={onCloseDialog} data = {{eventid: eventId, eventname: eventName2}} />}

            </div>
            </div>
            
    
        )
    }

    else if (flag === "A") {
        return (
            <div className={classes.pagemargin}>
                    
            <div className={classes.pagetitle} >Add</div> 
                    <div className={classes.searchbox}>
                    <SnackBar
                    open={open}
                    message={message}
                    severity={severity}
                    onClose={handleAlertNotifClose}
                    ></SnackBar>
            
                <Grid container spacing={4} rowSpacing ={6}>        
                <Grid key={0} item xs={2}>
                  <DivisionDropDownComp
                  onDivChange={e => onDivDropDownSelect(e)}>
                  </DivisionDropDownComp>
                </Grid>
                <Grid key={1} item xs={2}>
                 <FormControl  style={{minWidth: '100%'}}>
                  <TextField 
                  label="Event Name"
                  onChange={(e) => setEventName(e.target.value)}
                  value={eventName}
                   />
                </FormControl>
                </Grid>
              
                <Grid key = {2} item xs={8}></Grid>
                  <Grid key={3} item xs={2}>
                    <Button onClick={handleCancel} color="secondary" size = "large" style={{
                            minWidth: '100%',
                            minHeight: '120%',
                    }}>
                      Cancel
                    </Button>
                 </Grid>     
                 <Grid key={4} item xs={2}>
                    <Button color="primary" size = "large" style={{
                            minWidth: '100%',
                            minHeight: '120%',
                    }} onClick={saveData}>
                      Save
                    </Button>
                 </Grid>         
                </Grid> 
            
                </div>       
                            
            </div>)
    }
        ;}
export default EditEventsPage;
